import get from "lodash/get";
import { cloneElement } from "react";

const noMultiTypes = [
  "TextInput",
  "BooleanInput",
  "NullableBooleanField",
  "SelectInput",
];

export const customizeUiFilters = (uiFilters) => {
  return uiFilters.map((uiFilter) => {
    const type = get(uiFilter, "type.name");
    console.log(type);

    if (noMultiTypes.includes(type)) {
      return uiFilter;
    } else {
      return cloneElement(uiFilter, {
        multiple: true,
        value: uiFilter.value || undefined,
      });
    }
  });
};
